module.exports = __webpack_public_path__ + "static/media/logo-light.da5894c8.png";